import connectionProxy from './connectionProxy'

export const downloadPdf = (areaIds, controlledComponentIds, supervisoryIds) =>
  connectionProxy.http.get(`/produtos_controlados/download_pdf?area_id=${areaIds}&controlled_component_id=${controlledComponentIds}&supervisory_id=${supervisoryIds}`,  {
      responseType: 'arraybuffer'
  });

export const downloadXls = (areaIds, controlledComponentIds, supervisoryIds) =>
  connectionProxy.http.get(`/produtos_controlados/download_xls?area_id=${areaIds}&controlled_component_id=${controlledComponentIds}&supervisory_id=${supervisoryIds}`,  {
      responseType: 'arraybuffer'
  });



// WEBPACK FOOTER //
// ./src/api/controlledProductReport.js